import { render, staticRenderFns } from "./PartnerConfirmationPage.vue?vue&type=template&id=2f04ba18&scoped=true&"
import script from "./PartnerConfirmationPage.vue?vue&type=script&lang=js&"
export * from "./PartnerConfirmationPage.vue?vue&type=script&lang=js&"
import style0 from "./PartnerConfirmationPage.vue?vue&type=style&index=0&id=2f04ba18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f04ba18",
  null
  
)

export default component.exports